import React, { CSSProperties } from 'react'
import { Token } from '@uniswap/sdk'
import { RowBetween, RowFixed, AutoRow } from 'components/Row'
import { AutoColumn } from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import { TYPE } from 'theme'
import ListLogo from 'components/ListLogo'
import { useActiveWeb3React } from 'hooks'
import { useCombinedInactiveList } from 'state/lists/hooks'
import useTheme from 'hooks/useTheme'
import { ButtonPrimary } from 'components/Button'
import styled from 'styled-components'
import { useIsUserAddedToken, useIsTokenActive } from 'hooks/Tokens'
import { CheckCircle } from 'react-feather'

const TokenSection = styled.div`
  padding: 8px 20px;
  height: 56px;
`

const CheckIcon = styled(CheckCircle)`
  height: 16px;
  width: 16px;
  margin-right: 6px;
  stroke: ${({ theme }) => theme.green1};
`

const NameOverflow = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 12px;
`

export default function ImportRow({
  token,
  style,
  dim,
  showImportView,
  setImportToken
}: {
  token: Token
  style?: CSSProperties
  dim?: boolean
  showImportView: () => void
  setImportToken: (token: Token) => void
}) {
  // gloabls
  const { chainId } = useActiveWeb3React()
  const theme = useTheme()

  // check if token comes from list
  const inactiveTokenList = useCombinedInactiveList()
  const list = chainId && inactiveTokenList?.[chainId]?.[token.address]?.list

  // check if already active on list or local storage tokens
  const isAdded = useIsUserAddedToken(token)
  const isActive = useIsTokenActive(token)

  return (
    <TokenSection style={style}>
      <RowBetween>
        <AutoRow style={{ opacity: dim ? '0.6' : '1' }}>
          <CurrencyLogo currency={token} size={'24px'} />
          <AutoColumn gap="4px">
            <AutoRow>
              <TYPE.body ml="8px" fontWeight={500}>
                {token.symbol}
              </TYPE.body>
              <TYPE.darkGray ml="8px" fontWeight={300}>
                <NameOverflow title={token.name}>{token.name}</NameOverflow>
              </TYPE.darkGray>
            </AutoRow>
            {list && list.logoURI && (
              <RowFixed style={{ marginLeft: '8px' }}>
                <TYPE.small mr="4px" color={theme.text3}>
                  via {list.name}
                </TYPE.small>
                <ListLogo logoURI={list.logoURI} size="12px" />
              </RowFixed>
            )}
          </AutoColumn>
        </AutoRow>
        {!isActive && !isAdded ? (
          <ButtonPrimary
            width="fit-content"
            padding="6px 12px"
            fontWeight={500}
            fontSize="14px"
            onClick={() => {
              setImportToken && setImportToken(token)
              showImportView()
            }}
          >
            Import
          </ButtonPrimary>
        ) : (
          <RowFixed style={{ minWidth: 'fit-content' }}>
            <CheckIcon />
            <TYPE.main color={theme.green1}>Active</TYPE.main>
          </RowFixed>
        )}
      </RowBetween>
    </TokenSection>
  )
}
